/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import edit from './edit';
import icon from './icon';
var metadata = {
  name: "core/spacer",
  category: "layout",
  attributes: {
    height: {
      type: "number",
      "default": 100
    }
  }
};
import save from './save';
var name = metadata.name;
export { metadata, name };
export var settings = {
  title: __('Spacer'),
  description: __('Add white space between blocks and customize its height.'),
  icon: icon,
  edit: edit,
  save: save
};
//# sourceMappingURL=index.js.map